import { useMemoAsync } from "@opendash/core";
import { Form, Select } from "antd";
import { observer } from "mobx-react-lite";
import Parse from "parse";
import React from "react";
import {
  KnownClassNames,
  TicketMetaField,
} from "../../../../../../administration/ticket_creation/types/field_configs/Meta";
import { OD3_Source_Select } from "./parse_select/OD3_Source_Select";

type Props = {
  field: TicketMetaField & { type: "select_parse" };
  name?: string;
};

type PropsFor<T> = {
  field: TicketMetaField & { type: "select_parse"; className: T };
  name: string;
};

const SpecificParseSelectOptionsMap: Partial<
  Record<KnownClassNames, React.FC<PropsFor<KnownClassNames>>>
> = {
  OD3_Source: OD3_Source_Select as React.FC<PropsFor<"OD3_Source">>,
};

export const SelectParseInput = observer((props: Props) => {
  const className = props.field.className;
  const SpecificOption =
    className && className in SpecificParseSelectOptionsMap
      ? SpecificParseSelectOptionsMap[className as KnownClassNames]
      : undefined;

  const options = useMemoAsync(async () => {
    if (SpecificOption) return []; // specific options will handle their own data fetching

    const objects = await new Parse.Query(props.field.className)
      .limit(1_000_000) // maybe filter by search instead of limit at some point => e.g. .equalTo(props.field.display, "value")
      .ascending(props.field.display)
      .find();

    return objects.map((obj) => ({
      value: obj.id,
      label: obj.get(props.field.display),
    }));
  }, []);

  const mode = props.field.multiple ? "multiple" : undefined;

  return (
    <Form.Item
      name={props.name}
      label={props.field.label}
      help={props.field.description}
    >
      {SpecificOption && (
        <SpecificOption field={props.field as any} name={props.name} />
      )}
      {!SpecificOption && (
        <Select
          options={options}
          mode={mode}
          showSearch
          optionFilterProp="label"
        />
      )}
    </Form.Item>
  );
});
